import axiosClient from './axiosClient';

export const getStudents = (params) => {
  // If a driveId is provided, use the nested RESTful route
  if (params && params.driveId) {
    const { driveId, ...rest } = params;
    return axiosClient.get(`/admin/drives/${driveId}/students`, { params: rest });
  }
  return axiosClient.get('/admin/students', { params });
};

export const updateStudentStatus = (id, status) => {
  return axiosClient.put(`/admin/students/${id}/status`, { status });
};
